import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import TitlebarInner from './TitlebarInner'
import axios from 'axios';
import FooterPage from './FooterPage';

function BlogContent() {
  
  const blog_url = useParams();
  const [blogdata, setBlogdata] = useState([]);

  useEffect(() => {
    axios.get('https://cleverotech.com/blogs/blogs.json')
      .then(response => {
        const filteredData = response.data.blogs.filter((data) => {
          const titleSlug = data.title.toLowerCase()
            .replace(/\//g, '-')
            .replace(/ /g, '-')
            .replace(/:/g, '');
          return titleSlug === blog_url.blogcontent;
        });

        setBlogdata(filteredData);
      })
      .catch(error => console.error('Error fetching data:', error));
  }, [blog_url]);
  
  return (
    <>
        <TitlebarInner key="blog-content" PageName={blogdata[0]?.title} PageDec="We harness the tools of traditional and digital." />
        <main className="content bg-top-center bg-cover blog-background-image" id="lqd-site-content">
            <div id="lqd-contents-wrap">
              <section className="blog-posts custom-px-150">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="all-blog-posts">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="blog-post">
                                            <div className="blog-thumb">
                                                <img src="/images/blog-1.jpg" alt="images"/>
                                            </div>
                                            <div className="down-content">
                                                <span>Lifestyle</span>
                                                <a href="post-details.html">
                                                    <h4>Best Template Website for HTML CSS</h4>
                                                </a>
                                                <ul className="post-info">
                                                    <li><Link to="/">Admin</Link></li>
                                                    <li><Link to="/">May 31, 2020</Link></li>
                                                    <li><Link to="/">12 Comments</Link></li>
                                                </ul>
                                                <p>Stand Blog is a free HTML CSS template for your CMS theme. You
                                                    can easily adapt or customize it for any kind of CMS or website
                                                    builder. You are allowed to use it for your business. You are
                                                    NOT allowed to re-distribute the template ZIP file on any
                                                    template collection site for the download purpose. <a
                                                        rel="nofollow" className="highlight-text"
                                                        href="https://templatemo.com/contact"
                                                        target="_parent">Contact TemplateMo</a> for more info. Thank
                                                    you.</p>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 custom-px-50">
                            <div className="sidebar">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="sidebar-item search">
                                            <form id="search_form" name="gs" method="GET" action="#">
                                                <input type="text" className="searchText" placeholder="type to search..." autocomplete="on"/>
                                            </form>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="sidebar-item recent-posts">
                                            <div className="sidebar-heading">
                                                <h2>Recent Posts</h2>
                                            </div>
                                            <div className="content blog-side-content">
                                                <ul>
                                                    <li><a href="post-details.html">
                                                            <h5>Vestibulum id turpis porttitor sapien facilisis
                                                                scelerisque</h5>
                                                            <span>May 31, 2020</span>
                                                        </a></li>
                                                    <li><a href="post-details.html">
                                                            <h5>Suspendisse et metus nec libero ultrices varius eget
                                                                in risus</h5>
                                                            <span>May 28, 2020</span>
                                                        </a></li>
                                                    <li><a href="post-details.html">
                                                            <h5>Swag hella echo park leggings, shaman cornhole
                                                                ethical coloring</h5>
                                                            <span>May 14, 2020</span>
                                                        </a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              </section>
            </div>
        </main>
        <FooterPage/>
    </>
  )
}

export default BlogContent